function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", {
  id: "arrowIconTitle"
}, "Arrow");

var _ref3 = /*#__PURE__*/React.createElement("desc", {
  id: "arrowIconDesc"
}, "Arrow icon");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.97 0c6.61 0 11.969 5.36 11.969 11.97s-5.36 11.969-11.97 11.969S0 18.579 0 11.969 5.36 0 11.97 0zm-.454 6.948l-.002.004a1.131 1.131 0 0 0-.769-.303c-.63 0-1.14.51-1.14 1.14 0 .334.143.631.371.839l-.002.004 3.645 3.342-3.645 3.337.002.002a1.129 1.129 0 0 0-.372.838c0 .63.51 1.141 1.141 1.141.297 0 .566-.116.769-.303l.002.002 4.562-4.182a1.141 1.141 0 0 0 0-1.68l-4.562-4.181z"
});

var SvgArrow = function SvgArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-labelledby": "arrowIconTitle arrowIconDesc",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", {
    id: "arrowIconTitle"
  }, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow.506cce58.svg";
export { ForwardRef as ReactComponent };